import {ReactComponent as Icon} from "./list-ul.svg"

type StopwatchIconProps = {
	className?: string;
};

const BulletListIcon: React.FunctionComponent<StopwatchIconProps> = ({className}) => {
	return <Icon className={className}/>;
};

export default BulletListIcon;